import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { returnStatuses } from '@reveni-io/reveni-ui'

import ReturnGroupReminder from '@/components/ReturnGroupReminder/ReturnGroupReminder'
import { orderTransactionTypes } from '@/constants'
import useTransactionTypes from '@/hooks/useTransactionTypes/useTransactionTypes'

import ContactMessage from './ContactMessage/ContactMessage'
import ExchangeMessage from './ExchangeMessage/ExchangeMessage'
import Instructions from './Instructions/Instructions'
import OnHoldMessage from './onHoldMessage/onHoldMessage'
import RefundMessage from './RefundMessage/RefundMessage'
import RequestInfoMessage from './RequestInfoMessage/RequestInfoMessage'
import ReturnGroup from './ReturnGroup/ReturnGroup'
import * as Styles from './styles'

const ProcessCompletedMessage = ({
  refundMethod,
  orderAmount,
  storeName,
  storeSlug,
  customerEmail,
  exchangedForOrder,
  orderStatus,
  storeReplyToEmail,
  issueExchangeAtStatus,
  isCancellationsPortal,
  returnGroup,
  orders,
  contactMethod,
  contactUrl,
  refundOnHold,
}) => {
  const theme = useTheme()
  const { getOrderTransactionType } = useTransactionTypes()
  const orderTransactionType = getOrderTransactionType()
  const { t } = useTranslation()

  if (isCancellationsPortal && orderStatus !== returnStatuses.cancelled) {
    return (
      <Styles.Container>
        <p>{t('Tu solicitud ha sido creada con éxito.')}</p>
        <ContactMessage
          isCancellationsPortal={isCancellationsPortal}
          contactMethod={contactMethod}
          contactEmail={storeReplyToEmail}
          contactUrl={contactUrl}
        />
      </Styles.Container>
    )
  }

  return (
    <Styles.Container>
      <RequestInfoMessage orderTransactionType={orderTransactionType} orderStatus={orderStatus} />
      {orderStatus === returnStatuses.onHold && <OnHoldMessage />}
      {orderTransactionType === orderTransactionTypes.refund && orderStatus !== returnStatuses.onHold && (
        <RefundMessage
          refundMethod={refundMethod}
          orderAmount={orderAmount}
          storeName={storeName}
          refundOnHold={refundOnHold}
        />
      )}
      {orderTransactionType === orderTransactionTypes.exchange && orderStatus !== returnStatuses.onHold && (
        <ExchangeMessage
          exchangedForOrder={exchangedForOrder}
          orderTransactionType={orderTransactionType}
          orderStatus={orderStatus}
          isInstant={refundMethod?.is_instant}
          issueExchangeAtStatus={issueExchangeAtStatus}
          storeName={storeName}
        />
      )}
      {orderTransactionType === orderTransactionTypes.mixed && orderStatus !== returnStatuses.onHold && (
        <>
          {Number(orderAmount?.remaining_amount) > 0 && (
            <RefundMessage
              refundMethod={refundMethod}
              orderAmount={orderAmount}
              storeName={storeName}
              refundOnHold={refundOnHold}
            />
          )}
          <ExchangeMessage
            exchangedForOrder={exchangedForOrder}
            orderTransactionType={orderTransactionType}
            orderStatus={orderStatus}
            isInstant={refundMethod?.is_instant}
            issueExchangeAtStatus={issueExchangeAtStatus}
            storeName={storeName}
          />
        </>
      )}
      <Instructions
        customerEmail={customerEmail}
        orderTransactionType={orderTransactionType}
        exchangedForOrder={exchangedForOrder}
        orderStatus={orderStatus}
        storeReplyToEmail={storeReplyToEmail}
        contactMethod={contactMethod}
        contactUrl={contactUrl}
      />
      <ReturnGroup orders={orders} returnGroup={returnGroup} customerEmail={customerEmail} storeSlug={storeSlug} />
      <ReturnGroupReminder
        returnGroup={returnGroup}
        paddingBottom={theme.whiteLabel.spacing.sp16}
        paddingTop={orders?.length ? theme.whiteLabel.spacing.sp24 : 0}
      />
    </Styles.Container>
  )
}

export default ProcessCompletedMessage
